/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import * as regExp from './regExp';
import { formatDate } from './dates';

const ADULTS = 'взрослые';
const CHILDREN = 'дети';
export const prepareNameForSave = name => name
    ?.trim?.()
    ?.replace(/(\s){2,}/g, ' ')
    .replace(/ /g, '\u00A0') || '\u00A0';

export const makeFullName = (...props) => {
    if (props.some(Boolean)) {
        const [ firstName, lastName, middleName ] = props;
        return [ prepareNameForSave(lastName), prepareNameForSave(firstName), prepareNameForSave(middleName) ].join(' ');
    }
    return '';
};

// eslint-disable-next-line no-nested-ternary
export const makeShortFullName = (...args) => args.map((e, id) => (e ? (id > 0 ? `${e[0]}.` : e) : '')).join(' ');

export const clearPhone = x => (x || '').replace(/\D/g, '');

export const camelCaseWithSeparator = (str, separator = '_') => (str ? str.replace(/([A-Z])/g, g => `${separator}${g[0].toLowerCase()}`) : '');

export const toCamelCaseBySeparator = (str, separator = '_') => {
    const reg = new RegExp(`${separator}+(.)`, 'g');
    return str ? str.replace(reg, g => g[1].toUpperCase()) : '';
};

export const toPascalCase = str => (!str ? '' : `${str[0].toUpperCase()}${str.slice(1)}`);

export const toCamelCaseWithPrefix = (prefix, str) => `${prefix}${toPascalCase(str)}`;

export const formatPhone = (x, mask = '+999 (99) 999-99-99') => {
    if (!x) {
        return null;
    }
    let xx = clearPhone(x);
    const m = mask.split('');
    let phone = '';
    for (let i = 0; i < mask.length; i++) {
        if (m[i] === '9') {
            phone = phone.concat(xx[0]);
            xx = xx.slice(1);
        } else {
            phone = phone.concat(m[i]);
        }
    }
    return phone;
};

// TODO: come up with more relevant name
export const phoneForBackEnd = x => formatPhone(x, '999(99)999-99-99');

export const formatCurrency = x => x.toFixed(2).replace(regExp.currencyDisplay, '$1 ').replace('.', ',');

export const stringShortMaker = (string, findValue) => {
    const indexFindValue = string.indexOf(findValue);
    return indexFindValue > -1 ? `${string.substr(0, indexFindValue + findValue.length)}` : null;
};

export const capitalizeString = string => string.charAt(0).toUpperCase() + string.slice(1);

export const capitalize = (x) => {
    if (!x) {
        return x;
    }
    const s = ''.concat(x);
    return s[0].toUpperCase() + s.slice(1);
};

export const parseJson = (x) => {
    try {
        return JSON.parse(x);
    } catch (err) {
    // ignore
    }
    return {};
};

export const doctorAudience = ({
    adult, children, childrenAge, adultAgeTo, childrenAgeTo, adultAge,
}) => {
    const arr = [];
    adult && arr.push(`${ADULTS}${adultAge ? ` от ${adultAge}` : ''}${adultAgeTo ? ` до ${adultAgeTo}` : ''}`);
    if (children) {
        if (childrenAge && childrenAgeTo) {
            arr.push(`${CHILDREN} от ${childrenAge} до ${childrenAgeTo}`);
        } else if (childrenAge) {
            arr.push(`${CHILDREN} ${childrenAge}+`);
        } else if (childrenAgeTo) {
            arr.push(`${CHILDREN} от 0 до ${childrenAgeTo}`);
        } else {
            arr.push(`${CHILDREN}`);
        }
    }
    // children && arr.push(`${CHILDREN} ${childrenAge || 0}+`);
    return Array.hasData(arr) ? arr.join(' и ') : '-';
};

export const declensionOfNumber = (number, titles) => {
    const cases = [ 2, 0, 1, 1, 1, 2 ];
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
};

export const getPhoneNumberForForm = (phone) => {
    const phoneCleared = clearPhone(phone);
    if (regExp.belarusianClearPhone.test(phoneCleared)) {
        return formatPhone(phone);
    }
    return phone || '';
};

export const getQueryStringByObject = obj => Object.entries(obj)
    .filter(([ , val ]) => val)
    .map(([ key, val ]) => `${key}=${val}`)
    .join('&');

export const getCommonCod = (...args) => args.filter(e => e).join('.');

export const getDisplayContractName = ({
    contractType: { name }, number, startDate, endDate,
}) => `${name} №${number} (${formatDate([ startDate, endDate ])})`;

export const getDisplayContractNameWithBalance = ({ balance, ...contract }) => `${getDisplayContractName(contract)} Остаток: ${formatCurrency(balance)}`;
